<script lang="ts">import { stateUi } from "@infinitro/config";
import { GradientBorder, InfoCard } from "@infinitro/info-card";
import WinCardContent from "./win-card-content.svelte";
export let liveWin;
</script>

{#if $stateUi.liveWins.liveWinsStyle === 'alternative3'}
	<div class="win-card-alternative3">
		<GradientBorder
			radius={8}
			gradient="linear-gradient(180deg, var(--color-primary-500) 0%, rgba(255,255,255,0.1) 100%)"
		>
			<WinCardContent {liveWin} />
		</GradientBorder>
	</div>
{:else}
	<InfoCard
		noPadding
		flatBackground={true}
		width="192px"
		height="82px"
		borderRadius="8px"
		withoutBorder={true}
		backgroundImage={false}
		withoutOverflow={false}
		customStylesCard="border: none; overflow: visible;"
	>
		<WinCardContent {liveWin} />
	</InfoCard>
{/if}

<style>
	.win-card-alternative3 {
		height: 82px;
		width: 192px;
		border-radius: 8px;
		box-shadow: 0px 0px 5px 0px var(--color-primary-500)
}
</style>
